export default __webpack_public_path__ + "static/media/@afifchan5.11600c5a.jpeg";